import React, {useState, useEffect, useRef} from 'react';
import { connect } from 'react-redux';
import Head from '../../components/head/Head'
import Foot from '../../components/foot/Foot'
import StripedProgressBarnft1 from '../../components/progress/Progressnft1'
import StripedProgressBarnft2 from '../../components/progress/Progressnft2'
import StripedProgressBarnft3 from '../../components/progress/Progressnft3'
import NFTLevelProgress from '../../components/progress/NFTLevelProgress'
import NFTFireCanvas  from '../../components/progress/NFTFireCanvas'
import {  Input,message,Modal,Progress  } from 'antd';
import { init,isStartIdo,getIdoList,transferBnb,allIdoETH } from '../../utils/ethers'
import copy from 'copy-to-clipboard'
import {shareLink} from '../../utils/const'
import NumberFormat from 'react-number-format'
import contractAddress from "../../utils/contractAddress.json"
import Moment from 'react-moment'
import {getNftIndex} from "../../api";
import CountUp from "react-countup";
import { useTranslation } from 'react-i18next'
import { CSSTransition } from 'react-transition-group';
import {
    WarningOutlined,CloseOutlined,RightOutlined,DashboardOutlined
  } from '@ant-design/icons';
  import './index.less';
import { max } from 'moment';
const mapStateToProps=(state)=>{
    return{
        isLogin:state.isLogin,
        address:state.address,
        pAddress:state.pAddress,
        chain:state.chain,
        flash:state.flash,
    }
}

const Nft = (props) => {
    const { t } = useTranslation()
    const [num,setNum] = useState(0)
    const [big ,setBig] = useState(0)
    const [bonus,setBonus] = useState(0)
    const [level,setLevel] = useState(0)
    const [list,setlist] = useState([])
    const [locked,setLocked] =useState(0)
    const [allFee,setAllFee] =useState(0)
    const [per1,setPer1] = useState(0)
    const [per2,setPer2] = useState(0)
    const [zhiNum,setZhiNum] = useState(0)
    const [holdNum,setHoldNum] = useState(0)
    
    
  
    const ref = useRef()

    const _getPledgeCcerIndex= () =>{
        if(props.address.length === 0 || props.isLogin === false){
            return false
        }
        getNftIndex().then(res=>{
            if(res.code === 0 ){
                   setBig(res.data.big)
                setBonus(res.data.bonus)
                setLevel(res.data.level)
               setAllFee(res.data.allFee)
                setLocked(res.data.locked)
                setPer1(res.data.per1)
                setPer2(res.data.per2)
                setZhiNum(res.data.zhiNum)
                setHoldNum(res.data.holdNum)
                

                 if(res.data.list!==null){
                        setlist(res.data.list)
                    }

               

          
                

            }else{
                message.error(res.msg)
            }
        },error =>{
            message.error(error)
        })

    }

  

  

 

    
const openNewPagey = () => {
        window.open('https://web3.okx.com/zh-hans/nft/collection/bsc/spacex-nfts', '_blank');
      };

   

    

    

  



    useEffect(() => {
        //window.scrollTo(0, 0)
       
        _getPledgeCcerIndex()
           
    }, 
    // eslint-disable-next-line
    [props.isLogin,num]);

    

    return (
        <>
            <Head/>
            <div className='nftbg   w-full lg:w-1/3 md:w-1/3 sm:1/2  px-0 pt-12 text-white flex flex-col z-10'>
                            {/*  */}
                            
                            <div className='w-full lg:w-1/3 px-0   min-h-[270px]  flex flex-row  '>
                                <div className=' w-full lg:w-1/3 md:w-1/3 sm:1/2 min-h-[203px] mt-10  absolute flex flex-row justify-center items-center '>
                                    {/* spacex火箭喷射代码周围火焰 背景粒子闪烁呼吸效果 */}
                                        <div className="relative w-full h-[240px] flex items-center justify-center overflow-hidden">

  {/* 背景蓝白粒子 */}
  <div className="absolute inset-0 z-0 pointer-events-none">
    {Array.from({ length: 46 }).map((_, index) => (
      <span
        key={index}
        className="nft-twinkle-star"
        style={{
          left: `${(index * 29) % 100}%`,
          top: `${(index * 47) % 100}%`,
          animationDelay: `${(index % 12) * 0.22}s`,
        }}
      />
    ))}
  </div>

  {/* 中心能量光 */}
  <div className="nft-core-light" />

  {/* 四周火焰（背后） */}
  <div className="nft-fire fire-1" />
  <div className="nft-fire fire-2" />
  <div className="nft-fire fire-3" />
  <div className="nft-fire fire-4" />
<NFTFireCanvas />
  {/* NFT 火箭 */}
  <img
    className="relative z-30 nft-rocket-float"
    alt="spacex nft"
    src={require("../../assets/nft/rocket2.png")}
    style={{ width: "150px" }}
  />

  {/* 底部喷射火焰（图片上层） */}
  <div className="absolute z-50 left-1/2 top-[158px] -translate-x-1/2 w-[56px] h-[90px] pointer-events-none">

    <div
      className="
        absolute
        left-1/2
        top-0
        -translate-x-1/2
        w-[18px]
        h-[72px]
        rounded-b-full
        bg-gradient-to-b
        from-[#ffffff]
        via-[#ffb000]
        via-[#ff6a00]
        to-transparent
        blur-[3px]
        nft-flame-core
      "
    />

    <div
      className="
        absolute
        left-[8px]
        top-2
        w-[14px]
        h-[58px]
        rounded-b-full
        bg-gradient-to-b
        from-[#ffd17a]
        via-[#ff5b00]
        to-transparent
        blur-[4px]
        nft-flame-side
      "
    />

    <div
      className="
        absolute
        right-[8px]
        top-2
        w-[14px]
        h-[58px]
        rounded-b-full
        bg-gradient-to-b
        from-[#ffd17a]
        via-[#ff5b00]
        to-transparent
        blur-[4px]
        nft-flame-side
        nft-delay
      "
    />
  </div>

</div>
                                        
                                    {/*  */}
                                </div>
                                <div className='w-[53%] pl-5 flex flex-col z-40'>
                                    <div className='w-full mt-4 flex justify-start items-center'>
                                        <img className='mr-1'  src={require('../../assets/nft/i.png')} style={{"width":"4px"}}></img>
                                        <span className=' text-white text-base' >{t('nft.NFT任务中心')}</span>
                                    </div>
                                    
                                    
                                    <span className='mt-1 text-gray-300 text-[9px]' >{t('nft.完成考核，获取专属SPACEX NFT')}</span>
                                    
                                    
            
                                </div>
                                
                            </div>
                            {/*  */}
                            <div className=' mx-4 mt-3 px-3 pt-2  SWAPbg1 h-[305px]  flex flex-col z-[50]  '>
                                
                                <div className='mt-2 ml-1 flex flex-row justify-start items-center text-[8px] leading-[8px]'>
                                    <span className=' text-text1 text-xs '>01</span>
                                    <span className=' text-gray-200 text-[10px] ml-2'>{t('nft.NFT获取任务')}(Mint)</span>
                                </div>
                                <div>
                                    <NFTLevelProgress currentLevel={level} />
                                </div>
                                <div className="w-full mt-1 h-[135px]
                                                relative inline-flex flex-row items-center justify-start
                                                px-2 py-3 text-white   tracking-wider
                                                [--cut:8px] [--border:1px]
                                                before:absolute before:inset-0 before:bg-[#1D2024]
                                                before:[clip-path:polygon(var(--cut)_0,calc(100%_-_var(--cut))_0,100%_var(--cut),100%_calc(100%_-_var(--cut)),calc(100%_-_var(--cut))_100%,var(--cut)_100%,0_calc(100%_-_var(--cut)),0_var(--cut))]
                                                after:absolute after:inset-[var(--border)] after:bg-[#040B10]
                                                after:[clip-path:polygon(var(--cut)_0,calc(100%_-_var(--cut))_0,100%_var(--cut),100%_calc(100%_-_var(--cut)),calc(100%_-_var(--cut))_100%,var(--cut)_100%,0_calc(100%_-_var(--cut)),0_var(--cut))]
                                            ">
                               
                                    <div className=' z-10 w-full flex flex-col justify-start'>
                                         <div className='w-full h-8 flex flex-row justify-between items-center'>
                                            <div className=' w-10/12 flex flex-row justify-start items-center'>
                                                 <span className='ml-3 text-[11px] text-white'>{t('nft.星舰NFT')}</span>
                                                 <span className='ml-1 text-[#FB8111] text-[8px] '>★★★★★</span>
                                            </div>
                                          
                                            <div className='w-2/12 flex flex-col items-center justify-center h-8'>
                                                <span className='text-[8px] text-gray-400'>{t('nft.限有数量')}</span>
                                                <div className=' flex flex-row items-center'><span className='text-text1 text-[11px]'><CountUp start={0} end={holdNum} duration="1" decimals={0} /></span><span className='text-gray-400 text-[10px]'>/6</span></div>
                                            </div>
                                         </div>
                                         <div className="w-full mt-1 h-10
                                                relative inline-flex  items-center justify-start
                                                px-3 py-1 text-white   tracking-wider
                                                [--cut:6px] [--border:1px]
                                                before:absolute before:inset-0 before:bg-[#1D2024]
                                                before:[clip-path:polygon(var(--cut)_0,calc(100%_-_var(--cut))_0,100%_var(--cut),100%_calc(100%_-_var(--cut)),calc(100%_-_var(--cut))_100%,var(--cut)_100%,0_calc(100%_-_var(--cut)),0_var(--cut))]
                                                after:absolute after:inset-[var(--border)] after:bg-[#040B10]
                                                after:[clip-path:polygon(var(--cut)_0,calc(100%_-_var(--cut))_0,100%_var(--cut),100%_calc(100%_-_var(--cut)),calc(100%_-_var(--cut))_100%,var(--cut)_100%,0_calc(100%_-_var(--cut)),0_var(--cut))]
                                            ">
                                                <img className=' mr-2 z-10' alt='logo' src={require('../../assets/nft/icon1.png')} style={{"width":"17px"}}></img>
                                                <div className='w-full flex flex-col z-10'>
                                                    <div className=' flex flex-row justify-between items-center'>
                                                        <span className='text-[10px] text-gray-400'>{t('nft.推荐人数考核')}</span>
                                                        <div className='flex flex-row justify-end items-center'>
                                                            <span className=' text-text1 text-[10px]'><CountUp start={0} end={zhiNum} duration="1" decimals={0} /></span>
                                                            <span className=' text-gray-400 text-[10px]'>/9</span>
                                                        </div>
                                                    </div>
                                                    <div className='mt-[2px]'><StripedProgressBarnft1 value={per1} /></div>
                                                </div>
                                                {/* <div className='z-10 w-8 flex flex-row justify-end items-center text-gray-400 text-[10px]'>50%</div> */}
                                         </div>
                                         <div className="w-full mt-1 h-10
                                                relative inline-flex  items-center justify-start
                                                px-3 py-1 text-white   tracking-wider
                                                [--cut:6px] [--border:1px]
                                                before:absolute before:inset-0 before:bg-[#1D2024]
                                                before:[clip-path:polygon(var(--cut)_0,calc(100%_-_var(--cut))_0,100%_var(--cut),100%_calc(100%_-_var(--cut)),calc(100%_-_var(--cut))_100%,var(--cut)_100%,0_calc(100%_-_var(--cut)),0_var(--cut))]
                                                after:absolute after:inset-[var(--border)] after:bg-[#040B10]
                                                after:[clip-path:polygon(var(--cut)_0,calc(100%_-_var(--cut))_0,100%_var(--cut),100%_calc(100%_-_var(--cut)),calc(100%_-_var(--cut))_100%,var(--cut)_100%,0_calc(100%_-_var(--cut)),0_var(--cut))]
                                            ">
                                                <img className=' mr-2  z-10' alt='logo' src={require('../../assets/nft/icon2.png')} style={{"width":"17px"}}></img>
                                                <div className='w-full flex flex-col z-10'>
                                                    <div className=' flex flex-row justify-between items-center'>
                                                        <span className='text-[10px] text-gray-400'>{t('nft.小区业绩考核')}</span>
                                                        <div className='flex flex-row justify-end items-center'>
                                                            <span className=' text-text1 text-[10px]'><CountUp start={0} end={big} duration="1" decimals={4}/></span>
                                                            <span className=' text-gray-400 text-[10px]'>/25 BNB</span>
                                                        </div>
                                                    </div>
                                                    <div className='mt-[2px]'><StripedProgressBarnft1 value={per2} /></div>
                                                </div>
                                                
                                         </div>

                                    </div>
                                                
                                </div>
                               
                                
            
                                
                                
                                
                            </div>
                            {/*  */}

                             {/*  */}
                             
                            <div className=' mx-4 mt-3 px-3 pt-2 pb-4  nftHold min-h-[330px]  flex flex-col  z-[50]'>
                                
                                <div className='mt-1 flex flex-row justify-between items-center'>
                                    <div className='mt-1 ml-1 flex flex-row justify-start items-center text-[8px] leading-[8px]'>
                                        <span className=' text-text1 text-xs '>02</span>
                                        <span className=' text-gray-200 text-[10px] ml-2'>{t('nft.我的NFT资产')}</span>
                                    </div>
                                    <div className='mt-1 ml-1 flex flex-row justify-start items-center text-[8px] leading-[8px]'>
                                        <span className=' text-gray-400 text-[10px] ml-2'>{t('nft.总持有')}：</span>
                                         <span className=' text-text1 text-xs '>{holdNum}</span>
                                    </div>
                                </div>

                                {
                                    list.length>0?
                                    list.slice(0,5).map((item,index)=>{
                                        return(
                                            <>
                                                <div className="w-full mt-2 h-[100px]
                                                relative inline-flex flex-row items-center justify-start
                                                px-2 py-3 text-white   tracking-wider
                                                [--cut:8px] [--border:1px]
                                                before:absolute before:inset-0 before:bg-[#1D2024]
                                                before:[clip-path:polygon(var(--cut)_0,calc(100%_-_var(--cut))_0,100%_var(--cut),100%_calc(100%_-_var(--cut)),calc(100%_-_var(--cut))_100%,var(--cut)_100%,0_calc(100%_-_var(--cut)),0_var(--cut))]
                                                after:absolute after:inset-[var(--border)] after:bg-[#040B10]
                                                after:[clip-path:polygon(var(--cut)_0,calc(100%_-_var(--cut))_0,100%_var(--cut),100%_calc(100%_-_var(--cut)),calc(100%_-_var(--cut))_100%,var(--cut)_100%,0_calc(100%_-_var(--cut)),0_var(--cut))]
                                            ">
                                                <img className='  z-10 mr-[10px]' alt='' src={require('../../assets/ipo/logo1.png')} style={{"width":"50px"}}></img>
                                                <div className=' z-10 w-full flex flex-col justify-start'>
                                                    <div className='w-full h-8 flex flex-row justify-between items-center relative'>
                                                        <div className='  flex flex-col  items-start'>
                                                            <div className=' flex felx-row justify-start items-center'>
                                                                <span className=' text-[11px] text-white'>{t('nft.星舰NFT')}</span>
                                                                <span className='ml-1 border border-text1 rounded-[4px] text-[8px] px-1 text-text1'>TokenID: #{item.token_id}</span>
                                                            </div>
                                                            <div className='mt-1 flex flex-row justify-start items-center'>
                                                                <img className='  z-10 mr-[2px]' alt='' src={require('../../assets/nft/clock.png')} style={{"width":"9px"}}></img>
                                                                <span className=' text-[8px] text-gray-600'>{t('nft.获得时间')}：{item.add_time}</span>
                                                            </div>
                                                            
                                                            
                                                        </div>
                                                        <span className=' text-[10px] mr-2'><RightOutlined /></span>
                                            
                                                    </div>



                                                    <div className="w-full mt-2 h-10
                                                            relative inline-flex  items-center justify-start
                                                            px-1 py-1 text-white   tracking-wider
                                                            [--cut:6px] [--border:1px]
                                                            before:absolute before:inset-0 before:bg-[#1D2024]
                                                            before:[clip-path:polygon(var(--cut)_0,calc(100%_-_var(--cut))_0,100%_var(--cut),100%_calc(100%_-_var(--cut)),calc(100%_-_var(--cut))_100%,var(--cut)_100%,0_calc(100%_-_var(--cut)),0_var(--cut))]
                                                            after:absolute after:inset-[var(--border)] after:bg-[#040B10]
                                                            after:[clip-path:polygon(var(--cut)_0,calc(100%_-_var(--cut))_0,100%_var(--cut),100%_calc(100%_-_var(--cut)),calc(100%_-_var(--cut))_100%,var(--cut)_100%,0_calc(100%_-_var(--cut)),0_var(--cut))]
                                                        ">
                                                            <div className="w-1/3 flex flex-row justify-center items-center z-10">
                                                            
                                                                <div className='flex flex-col '>
                                                                    <span className='text-gray-400 text-[8px] text-center'>{t('nft.已释放')}</span>
                                                                    <span className='text-[10px] text-center text-[#1E7CDC]'><NumberFormat
                                                thousandsGroupStyle="thousand"
                                                value={item.all_bonus}
                                                prefix=""
                                                decimalSeparator="."
                                                displayType="text"
                                                type="text"
                                                thousandSeparator={true}
                                                fixedDecimalScale={true}
                                                allowNegative={false}
                                                decimalScale={0} /></span>
                                                                </div>
                                                            </div>
                                                            <div className=' h-5 w-px bg-gray-800 mx-2 z-10'></div>
                                                            <div className="w-1/3 flex flex-row justify-center items-center z-10">
                                                                
                                                                <div className='flex flex-col '>
                                                                    <span className='text-gray-400 text-[8px] text-center'>{t('nft.总锁仓')}</span>
                                                                    <span className='text-[10px] text-center text-text1'><NumberFormat
                                                thousandsGroupStyle="thousand"
                                                value={item.max}
                                                prefix=""
                                                decimalSeparator="."
                                                displayType="text"
                                                type="text"
                                                thousandSeparator={true}
                                                fixedDecimalScale={true}
                                                allowNegative={false}
                                                decimalScale={0} /></span>
                                                                </div>
                                                            </div>
                                                            <div className=' h-5 w-px bg-gray-800 mx-2 z-10'></div>
                                                            <div className="w-1/3 flex flex-row justify-center items-center z-10">
                                                            
                                                                <div className='flex flex-col '>
                                                                    <span className='text-gray-400 text-[8px] text-center'>{t('nft.税费收益')}</span>
                                                                    <span className='text-[10px] text-center text-green-500'>
                                                                        <NumberFormat
                                                thousandsGroupStyle="thousand"
                                                value={item.fee}
                                                prefix=""
                                                decimalSeparator="."
                                                displayType="text"
                                                type="text"
                                                thousandSeparator={true}
                                                fixedDecimalScale={true}
                                                allowNegative={false}
                                                decimalScale={6} />
                                                                    </span>
                                                                </div>
                                                            </div>
                                                    </div>
                                                    

                                                </div>
                                                            
                                            </div>
                                            </>
                                        )
                                    }):(
                                        
                                        <div  className=' w-full h-[210px] py-3 mt-5 flex flex-col items-center justify-center text-gray-600 text-xs'>
                                            <img className='  z-10 grayscale-[100%]' alt='' src={require('../../assets/nft/nft1.png')} style={{"width":"80px"}}></img>
                                                No data
                                        </div>
                                    )
                                }
                                
                                
{/* 
                                <div className="w-full mt-2 h-[100px]
                                                relative inline-flex flex-row items-center justify-start
                                                px-2 py-3 text-white   tracking-wider
                                                [--cut:8px] [--border:1px]
                                                before:absolute before:inset-0 before:bg-[#1D2024]
                                                before:[clip-path:polygon(var(--cut)_0,calc(100%_-_var(--cut))_0,100%_var(--cut),100%_calc(100%_-_var(--cut)),calc(100%_-_var(--cut))_100%,var(--cut)_100%,0_calc(100%_-_var(--cut)),0_var(--cut))]
                                                after:absolute after:inset-[var(--border)] after:bg-[#040B10]
                                                after:[clip-path:polygon(var(--cut)_0,calc(100%_-_var(--cut))_0,100%_var(--cut),100%_calc(100%_-_var(--cut)),calc(100%_-_var(--cut))_100%,var(--cut)_100%,0_calc(100%_-_var(--cut)),0_var(--cut))]
                                            ">
                                    <img className='  z-10 mr-[10px]' alt='' src={require('../../assets/nft/nft1.png')} style={{"width":"50px"}}></img>
                                    <div className=' z-10 w-full flex flex-col justify-start'>
                                         <div className='w-full h-8 flex flex-row justify-between items-center relative'>
                                            <div className=' w-full flex flex-col  items-start'>
                                                <div className=' flex felx-row justify-start items-center'>
                                                    <span className=' text-[11px] text-white'>{t('nft.星舰NFT')}</span>
                                                    <span className='ml-1 border border-[#1E7CDC] rounded-[4px] text-[8px] px-1 text-[#1E7CDC] '>TokenID: #0</span>
                                                </div>
                                                <div className='mt-1 flex flex-row justify-start items-center'>
                                                    <img className='  z-10 mr-[2px]' alt='' src={require('../../assets/nft/clock.png')} style={{"width":"9px"}}></img>
                                                    <span className=' text-[8px] text-gray-600'>{t('nft.获得时间')}：2014-20-20 12:12:12</span>
                                                </div>
                                                
                                                 
                                            </div>
                                            <span className=' text-[10px]'><RightOutlined /></span>
                                
                                         </div>



                                         <div className="w-full mt-2 h-10
                                                relative inline-flex  items-center justify-start
                                                px-1 py-1 text-white   tracking-wider
                                                [--cut:6px] [--border:1px]
                                                before:absolute before:inset-0 before:bg-[#1D2024]
                                                before:[clip-path:polygon(var(--cut)_0,calc(100%_-_var(--cut))_0,100%_var(--cut),100%_calc(100%_-_var(--cut)),calc(100%_-_var(--cut))_100%,var(--cut)_100%,0_calc(100%_-_var(--cut)),0_var(--cut))]
                                                after:absolute after:inset-[var(--border)] after:bg-[#040B10]
                                                after:[clip-path:polygon(var(--cut)_0,calc(100%_-_var(--cut))_0,100%_var(--cut),100%_calc(100%_-_var(--cut)),calc(100%_-_var(--cut))_100%,var(--cut)_100%,0_calc(100%_-_var(--cut)),0_var(--cut))]
                                            ">
                                                <div className="w-16 flex flex-row justify-center items-center z-10">
                                                  
                                                    <div className='flex flex-col '>
                                                        <span className='text-gray-400 text-[8px] text-center'>{t('nft.已释放')}</span>
                                                        <span className='text-[10px] text-center text-[#1E7CDC]'>100,000M</span>
                                                    </div>
                                                </div>
                                                <div className=' h-5 w-px bg-gray-800 mx-2 z-10'></div>
                                                <div className="w-14 flex flex-row justify-center items-center z-10">
                                                    
                                                    <div className='flex flex-col '>
                                                        <span className='text-gray-400 text-[8px] text-center'>{t('nft.总锁仓')}</span>
                                                        <span className='text-[10px] text-center text-text1'>∞</span>
                                                    </div>
                                                </div>
                                                <div className=' h-5 w-px bg-gray-800 mx-2 z-10'></div>
                                                <div className="w-20 flex flex-row justify-center items-center z-10">
                                                   
                                                    <div className='flex flex-col '>
                                                        <span className='text-gray-400 text-[8px] text-center'>{t('nft.税费收益')}</span>
                                                        <span className='text-[10px] text-center text-green-500'>$0.000195</span>
                                                    </div>
                                                </div>
                                         </div>
                                         

                                    </div>
                                                
                                </div>
                                <div className="w-full mt-2 h-[100px]
                                                relative inline-flex flex-row items-center justify-start
                                                px-2 py-3 text-white   tracking-wider
                                                [--cut:8px] [--border:1px]
                                                before:absolute before:inset-0 before:bg-[#1D2024]
                                                before:[clip-path:polygon(var(--cut)_0,calc(100%_-_var(--cut))_0,100%_var(--cut),100%_calc(100%_-_var(--cut)),calc(100%_-_var(--cut))_100%,var(--cut)_100%,0_calc(100%_-_var(--cut)),0_var(--cut))]
                                                after:absolute after:inset-[var(--border)] after:bg-[#040B10]
                                                after:[clip-path:polygon(var(--cut)_0,calc(100%_-_var(--cut))_0,100%_var(--cut),100%_calc(100%_-_var(--cut)),calc(100%_-_var(--cut))_100%,var(--cut)_100%,0_calc(100%_-_var(--cut)),0_var(--cut))]
                                            ">
                                    <img className='  z-10 mr-[10px]' alt='' src={require('../../assets/nft/nft1.png')} style={{"width":"50px"}}></img>
                                    <div className=' z-10 w-full flex flex-col justify-start'>
                                         <div className='w-full h-8 flex flex-row justify-between items-center relative'>
                                            <div className=' w-full flex flex-col  items-start'>
                                                <div className=' flex felx-row justify-start items-center'>
                                                    <span className=' text-[11px] text-white'>{t('nft.星舰NFT')}</span>
                                                    <span className='ml-1 border border-[#F5B932] rounded-[4px] text-[8px] px-1 text-[#F5B932] '>TokenID: #0</span>
                                                </div>
                                                <div className='mt-1 flex flex-row justify-start items-center'>
                                                    <img className='  z-10 mr-[2px]' alt='' src={require('../../assets/nft/clock.png')} style={{"width":"9px"}}></img>
                                                    <span className=' text-[8px] text-gray-600'>{t('nft.获得时间')}：2014-20-20 12:12:12</span>
                                                </div>
                                                
                                                 
                                            </div>
                                            <span className=' text-[10px]'><RightOutlined /></span>
                                
                                         </div>



                                         <div className="w-full mt-2 h-10
                                                relative inline-flex  items-center justify-start
                                                px-1 py-1 text-white   tracking-wider
                                                [--cut:6px] [--border:1px]
                                                before:absolute before:inset-0 before:bg-[#1D2024]
                                                before:[clip-path:polygon(var(--cut)_0,calc(100%_-_var(--cut))_0,100%_var(--cut),100%_calc(100%_-_var(--cut)),calc(100%_-_var(--cut))_100%,var(--cut)_100%,0_calc(100%_-_var(--cut)),0_var(--cut))]
                                                after:absolute after:inset-[var(--border)] after:bg-[#040B10]
                                                after:[clip-path:polygon(var(--cut)_0,calc(100%_-_var(--cut))_0,100%_var(--cut),100%_calc(100%_-_var(--cut)),calc(100%_-_var(--cut))_100%,var(--cut)_100%,0_calc(100%_-_var(--cut)),0_var(--cut))]
                                            ">
                                                <div className="w-16 flex flex-row justify-center items-center z-10">
                                                  
                                                    <div className='flex flex-col '>
                                                        <span className='text-gray-400 text-[8px] text-center'>{t('nft.已释放')}</span>
                                                        <span className='text-[10px] text-center text-[#F5B932]'>100,000M</span>
                                                    </div>
                                                </div>
                                                <div className=' h-5 w-px bg-gray-800 mx-2 z-10'></div>
                                                <div className="w-14 flex flex-row justify-center items-center z-10">
                                                    
                                                    <div className='flex flex-col '>
                                                        <span className='text-gray-400 text-[8px] text-center'>{t('nft.总锁仓')}</span>
                                                        <span className='text-[10px] text-center text-text1'>∞</span>
                                                    </div>
                                                </div>
                                                <div className=' h-5 w-px bg-gray-800 mx-2 z-10'></div>
                                                <div className="w-20 flex flex-row justify-center items-center z-10">
                                                   
                                                    <div className='flex flex-col '>
                                                        <span className='text-gray-400 text-[8px] text-center'>{t('nft.税费收益')}</span>
                                                        <span className='text-[10px] text-center text-green-500'>$0.000195</span>
                                                    </div>
                                                </div>
                                         </div>
                                         

                                    </div>
                                                
                                </div> */}



                                <div className="w-full mt-3 h-10
                                                relative inline-flex  items-center justify-start
                                                px-1 py-1 text-white   tracking-wider
                                                [--cut:6px] [--border:1px]
                                                before:absolute before:inset-0 before:bg-[#1D2024]
                                                before:[clip-path:polygon(var(--cut)_0,calc(100%_-_var(--cut))_0,100%_var(--cut),100%_calc(100%_-_var(--cut)),calc(100%_-_var(--cut))_100%,var(--cut)_100%,0_calc(100%_-_var(--cut)),0_var(--cut))]
                                                after:absolute after:inset-[var(--border)] after:bg-[#040B10]
                                                after:[clip-path:polygon(var(--cut)_0,calc(100%_-_var(--cut))_0,100%_var(--cut),100%_calc(100%_-_var(--cut)),calc(100%_-_var(--cut))_100%,var(--cut)_100%,0_calc(100%_-_var(--cut)),0_var(--cut))]
                                            ">
                                    <div className="w-1/3 flex flex-row justify-center items-center z-10">
                                        <img className=' mr-2' alt='' src={require('../../assets/nft/a1.png')} style={{"width":"15px"}}></img>
                                        <div className='flex flex-col '>
                                            <span className='text-gray-400 text-[8px]'>{t('nft.总释放量')}</span>
                                            <span className='text-[10px] text-text1'>
                                                <NumberFormat
                                                thousandsGroupStyle="thousand"
                                                value={bonus}
                                                prefix=""
                                                decimalSeparator="."
                                                displayType="text"
                                                type="text"
                                                thousandSeparator={true}
                                                fixedDecimalScale={true}
                                                allowNegative={false}
                                                decimalScale={0} />
                                            </span>
                                        </div>
                                    </div>
                                    <div className=' h-5 w-px bg-gray-800 mx-2 z-10'></div>
                                    <div className="w-1/3 flex flex-row justify-center items-center z-10">
                                        <img className=' mr-2' alt='' src={require('../../assets/nft/a2.png')} style={{"width":"15px"}}></img>
                                        <div className='flex flex-col '>
                                            <span className='text-gray-400 text-[8px]'>{t('nft.累积锁仓')}</span>
                                            <span className='text-[10px] text-text1'>
                                                <NumberFormat
                                                thousandsGroupStyle="thousand"
                                                value={locked}
                                                prefix=""
                                                decimalSeparator="."
                                                displayType="text"
                                                type="text"
                                                thousandSeparator={true}
                                                fixedDecimalScale={true}
                                                allowNegative={false}
                                                decimalScale={0} />
                                            </span>
                                        </div>
                                    </div>
                                    <div className=' h-5 w-px bg-gray-800 mx-2 z-10'></div>
                                    <div className="w-1/3 flex flex-row justify-center items-center z-10">
                                        <img className=' mr-2' alt='' src={require('../../assets/nft/a3.png')} style={{"width":"15px"}}></img>
                                        <div className='flex flex-col '>
                                            <span className='text-gray-400 text-[8px]'>{t('nft.税费总收益')}</span>
                                            <span className='text-[10px] text-green-500'><NumberFormat
                                                thousandsGroupStyle="thousand"
                                                value={allFee}
                                                prefix=""
                                                decimalSeparator="."
                                                displayType="text"
                                                type="text"
                                                thousandSeparator={true}
                                                fixedDecimalScale={true}
                                                allowNegative={false}
                                                decimalScale={6} /></span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/*  */}
                            
            
                             {/*  */}
                            <div onClick={openNewPagey} className=' mx-4 mt-3 airDataBg2  h-[55px] px-4  flex flex-row items-center relative'>
                                <img className='mr-2' alt='' src={require('../../assets/nft/okx.png')} style={{"width":"60px"}}></img>
                                <div className="ml-3 flex flex-col">
                                    <span className=' text-[10px] text-text2'>{t('nft.前往 OKX NFT 交易市场')}</span>
                                    <span className=' text-[8px] text-gray-400'>{t('nft.探索更多 NFT·交易·惊喜不断')}</span>
                                </div>
                                <img className=' absolute right-4' alt='' src={require('../../assets/nft/ri.png')} style={{"width":"45px"}}></img>
                            </div>
                            {/*  */}
                         
            
                            
                            {/*  */}
                            <div className=' h-[80px]'></div>
                        </div>

            
            
           

           <Foot/>
        </>
    );
}

const mapDispatchToProps = (dispatch) =>{
    return{

        setIsLogin(value){
            const action ={type:"setIsLogin",value:value}
            dispatch(action)
        },

        setPAddress(value){
            const action ={type:"setPAddress",value:value}
            dispatch(action)
        }
    }
}
export default connect(mapStateToProps,mapDispatchToProps)(Nft);
